import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { makeSelectSprayWorksheetEquipmentSetTankVolume } from 'scenes/Spray/scenes/Diary/components/PrintSprayWorksheetModal/components/PrintSprayWorksheetEquipmentSet/selectors';
import { selectSprayWorksheetProducts } from 'scenes/Spray/scenes/Diary/components/PrintSprayWorksheetModal/components/PrintSprayWorksheetProducts/components/PrintSprayWorksheetProductsTable/selectors';
import { selectSprayWorksheetEntitySummaries } from 'scenes/Spray/scenes/Diary/components/PrintSprayWorksheetModal/components/PrintSprayWorksheetCompletionDetails/components/PrintSprayWorksheetCompletionDetailsTable/selectors';

import get from 'lodash.get';

const selectSprayWorksheetEntitySummariesTotalTanks = createDeepEqualSelector(
    selectSprayWorksheetEntitySummaries,
    makeSelectSprayWorksheetEquipmentSetTankVolume(),
    selectSprayWorksheetProducts,
    (entitySummaries, tankVolume, products) => {
        const waterRate: number = get(products, [0, 'waterRate'], 0);

        const sum = entitySummaries.reduce((total, entitySummary) => {
            const sumTotalArea = get(entitySummary, 'sumTotalArea');
            const sprayedRatio = get(entitySummary, 'sprayedRatio');
            return (
                total +
                Number((sumTotalArea * sprayedRatio * waterRate) / tankVolume)
            );
        }, 0);

        return sum.toFixed(2);
    }
);

const makeSelectSprayWorksheetEntitySummariesTotalTanks =
    (): typeof selectSprayWorksheetEntitySummariesTotalTanks =>
        selectSprayWorksheetEntitySummariesTotalTanks;

export { makeSelectSprayWorksheetEntitySummariesTotalTanks };
